import { ofType } from "redux-observable";
import { ignoreElements, tap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { IdSoundGroup } from "../../../utils/sound/IdSoundGroup";
import { utilSound } from "../../../utils/sound/utilSound";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionApp } from "../../app/actionApp";
export var epicSoundsRestoreSettings = function (action$) {
    return action$.pipe(ofType(TypeActionApp.Init), tap(function () {
        var _a;
        var settings = utilPersistence.getValue(IdPersistence.Settings, (_a = {},
            _a[IdSoundGroup.Global] = false,
            _a[IdSoundGroup.Music] = false,
            _a[IdSoundGroup.Sound] = false,
            _a));
        utilSound.muteSoundGroup(IdSoundGroup.Global, settings[IdSoundGroup.Global]);
        utilSound.muteSoundGroup(IdSoundGroup.Music, settings[IdSoundGroup.Music]);
        utilSound.muteSoundGroup(IdSoundGroup.Sound, settings[IdSoundGroup.Sound]);
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsRestoreSettings.ts
// module id = 2411
// module chunks = 3